export default __webpack_public_path__ + "images/cancelled_cb0b9a.svg";